<template>
    <div class="CourseDetail_wrap">
        <div class="banner_wrap" :style="{'background':'url('+courseInfo.img+')'}">
            <el-page-header @back="$core.goBack" ></el-page-header>
            <div class="banner_title">{{courseInfo.title}}</div>
            <div class="banner_text flex-column-between">
                <div><span>语言：&nbsp;&nbsp;</span><div>{{courseInfo.language}}</div></div>
                <div><span>环境配置：&nbsp;&nbsp;</span><div>{{courseInfo.configure}}</div></div>
                <div><span>学习目标：&nbsp;&nbsp;</span>
                    <div>{{ courseInfo.target }}</div>
                </div>
            </div>
            <div class="flex-between">
                <el-button class="show_button" type="primary" @click="isStartVisible = true">开始实验环境</el-button>
                <div class="icon_wrap flex-between" >
                    <i class="iconfont icon-dianzan" @click.stop="setLike(id)" :style="courseInfo.isLike == 1 ? 'color:#5277F7':'' ">&nbsp;{{courseInfo.starCount}}</i>
                    <i @click="getCollectData" class="iconfont icon-xingxing" v-if="courseInfo.isCollect == 0">&nbsp;未收藏</i>
                    <i @click="cancelCollect" class="iconfont icon-xingxing" :style="courseInfo.isCollect == 1 ? 'color:#5277F7':'' " v-else>&nbsp;已收藏</i>
                    <!-- <i @click="cancelCollect" class="iconfont icon-xingxing" :style="courseInfo.isCollect == 1 ? 'color:#5277F7':'' ">&nbsp;已收藏</i> -->
                </div>
            </div>
        </div>
        <div class="course_content course_intro">
            <div class="content_title">简介</div>
            <div class="intro_text">{{courseInfo.introduction}}</div>
        </div>
        <div class="course_content ">
            <div class="content_title">目录</div>
        </div>
        <div class="menu">
                <div class="menu_title">{{courseInfo.title}}</div>
                <div class="course_menu flex-between">
                    <div class="item" v-for="(item,index) in menus" :key="index" @click="isStartVisible = true">
                        {{ index < 9 ? `0` + `${ index + 1}`:`${index + 1}`}}.&nbsp;&nbsp;{{item.menuName}}
                    </div>
                </div>
        </div>
        <!-- 启动环境 -->
        <el-dialog :visible.sync='isStartVisible' width='22%' center>
            <span class='dialog_text'>是否立即启动环境？</span>
            <span slot='footer' class='dialog-footer'>
              <el-button type='primary' @click='toExperiment'>是</el-button>
              <el-button @click='isStartVisible = false'>否</el-button>
            </span>
        </el-dialog>
        <!-- 收藏文件-->
        <el-dialog  title="添加到收藏夹"  :visible.sync="favoritesVisible"  width="22%"  center>
            <div >
                <el-checkbox-group v-model="selectId" class="select_wrap">
                  <el-checkbox v-for="item in fileList" :key='item.id' :label="item.id">{{item.favoritesName}}</el-checkbox>
                </el-checkbox-group>
            </div>
            <div class='flex-between add_file'>
                <el-input placeholder='输入文件夹名称' v-model='fileName'></el-input>
                <el-button @click='createFile'>新建</el-button>
            </div>
            <span slot='footer' class='dialog-footer'>
              <el-button type='primary' style='width:120px' @click='addCollect'>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {
    addFavorites,
    addResourceToFavorites,
    giveLike,
    queryFavorites,
    queryFavoritesWithResourceId,
    queryResourceMenu
} from '../../../utils/api';

export default {
    data() {
        return {
            selectId: [],
            fileName: '',
            fileList: [],//收藏文件夹组
            favoritesVisible: false,//添加到收藏夹是否可见
            id: this.$store.state.courseId,
            courseInfo: {
                img: '',
                title: '',
                language: '',
                configure: '',
                target: '',
                introduction: '',
                starCount: '',
                link: '',
                isLike: '',//是否点赞，0未赞，1已赞
                isCollect: ''//是否收藏
            },
            isStartVisible: false,
            menus: []
        };
    },
    mounted() {
        this.getmenu();
    },
    methods: {
        //给数据资源点赞
        setLike(itemId) {
            giveLike({ resourceId: itemId }).then(res => {
                this.getmenu();
            }).catch(err => {
            });
        },
        //取消收藏
        cancelCollect() {
            queryFavoritesWithResourceId({ resourceId: this.id }).then(res => {
                this.selectId = res.data.filter(i => {
                    return i.isInside != 0;
                }).map(item => {
                        return item.id;
                    }
                );
                this.getCollectData();
            }).catch(err=>{})
            },
            //将资源添加到收藏夹
            addCollect(){
                let params = {
                    favoritesIds:this.selectId,
                    resourceId:this.id
                }
                addResourceToFavorites(params).then(res => {
                    this.selectId = '';
                    this.$message.success('收藏成功');
                    this.getmenu();
                    this.favoritesVisible = false;
                }).catch(err=>{})
            },
            //新建收藏夹
            createFile(){
                addFavorites({ favoritesName: this.fileName }).then(res => {
                    this.fileName = '';
                    this.$message.success('创建成功');
                    this.getCollectData();
                }).catch(err=>{})
            },
            //查询收藏夹列表
            getCollectData(){
                this.favoritesVisible = true
                let params = {
                    keyWord:'',
                    page:1,
                    size:10
                }
                queryFavorites(params).then(res => {
                    this.fileList = res.data.list;
                }).catch(err=>{})
            },
            //进入实验
            toExperiment(){
                this.isStartVisible = false
                window.open(this.courseInfo.link)
            },
            //进入案例
            toNextPage(url){
                if(!url){
                    location.href = url
                }

            },
            //获取资源目录
            getmenu(){
                queryResourceMenu({ resourceId: this.id }).then(res => {
                    this.courseInfo.img = res.dataResourceInfo.bgImageUrl;
                    this.courseInfo.language = res.dataResourceInfo.programLanguage;
                    this.courseInfo.configure = res.dataResourceInfo.envConfig;
                    this.courseInfo.target = res.dataResourceInfo.studyTarget;
                    this.courseInfo.introduction = res.dataResourceInfo.summary;
                    this.courseInfo.starCount = res.dataResourceInfo.likeNum;
                    this.courseInfo.title = res.dataResourceInfo.dataTitle;
                    this.courseInfo.isLike = res.dataResourceInfo.isLike;
                    this.courseInfo.isCollect = res.dataResourceInfo.isCollect;
                    this.courseInfo.link = res.dataResourceInfo.jupyterLink;
                    this.menus = res.data;
                }).catch(err => {
                });
            },
    }
}
</script>
<style lang="scss" scoped>
.add_file{
    box-sizing: border-box;
    padding: 0px 50px;
}
.select_wrap{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    box-sizing: border-box;
    padding: 0px 0px 15px 50px;
    .el-checkbox{
        height: 28px;
    }
}
/deep/.el-dialog__title{
    color: #5277F7;
    font-weight: 500;
    font-size: 25px;
}
/deep/.el-dialog__body{
    text-align: center;

}
.dialog_text{
    font-size: 22px;
    font-family: '黑体';
    color: #002D72;
}
/deep/.el-page-header__left:hover{
        opacity: 0.7;
    }
    /deep/.el-page-header__left{
        position: relative;
        top: 90px;
        left: 20px;
        .el-icon-back{
            font-size: 20px;
            color: #5277F7;
        }
        .el-page-header__title{
            font-size: 20px;
            color: #5277F7;
        }

    }
    .menu{
        background: #F5F9FF;
        padding: 50px 300px;
        .menu_title{
            opacity: 0.8;
            font-size: 27px;
            font-weight: 600;
            color: #3C3C3C;
            margin-bottom: 20px;
        }
        .course_menu{
            display: flex;
            justify-content: start;
            flex-wrap: wrap;
            box-sizing: border-box;
            .item{
                opacity: 0.8;
                width: 25%;
                height: 60px;
                line-height: 60px;
                font-size: 22px;
                color: #3C3C3C;

            }
            .item:hover{
                cursor: pointer;
                color: #5277F7;
                opacity: 0.8;
            }
        }

    }
    .course_intro{
        min-height: 150px;
        .intro_text{
            line-height: 1.5;
            min-height: 80px;
            font-size: 24px;
            font-family: '黑体';
            color: #3C3C3C;
        }
    }
    .course_content{
        width: 100%;
        box-sizing: border-box;
        padding: 0px 300px;
        background: white;
        margin-top: 30px;
        box-shadow: 1px 5px 11px -2px rgba(0,0,0,0.1);
        -webkit-box-shadow: 1px 5px 11px -2px rgba(0,0,0,0.1);
        -moz-box-shadow: 1px 5px 11px -2px rgba(0,0,0,0.1);
        .content_title{
            font-size: 30px;
            letter-spacing: 2px;
            font-weight: 600;
            color: #5277F7;
            height: 100px;
            line-height: 100px;
        }
    }
    .CourseDetail_wrap{
        background: #FAFAFA;
    }
    .banner_wrap{
        width: 100%;
        height: 745px;
        background-position: 0px 0px;
        background-size:100% 100% ;
        background-repeat: no-repeat;
        .banner_title{
            font-size: 60px;
            color: #5277F7;
            font-weight: 600;
            padding: 150px 0px 50px 180px;
            letter-spacing: 2px;
        }
        .banner_text{
            height: 200px;
            padding-left: 180px;
            color:#333333;
            font-size: 25px;
            width: 650px;
            line-height: 1.5;
            // text-align:justify;
            opacity: 0.8;
            div{
                display: flex;
                span{
                // width: 120px;
                white-space:nowrap;
                font-weight: 600;
            }
            }

            // text-align-last:justify;
        }
        .show_button{
            margin:50px 0px 0px 180px;
            width: 250px;
            height: 65px;
            font-size: 25px;
            border-radius: 8px;
        }
        .icon_wrap{
            width: 200px;
            color: white;
            position: relative;
            top: 150px;
            right: 120px;
            .icon-dianzan{
                margin-right: 20px;
                font-size: 25px;
            }
            .icon-xingxing{
                font-size: 23px;
            }
            .icon-xingxing:hover{
                color: #002D72;
            }
            .icon-dianzan:hover{
                color: #002D72;
            }
        }
    }
</style>
